import { render, staticRenderFns } from "./ValidationFeedback.vue?vue&type=template&id=478a9a1e&scoped=true&"
import script from "./ValidationFeedback.vue?vue&type=script&lang=js&"
export * from "./ValidationFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ValidationFeedback.vue?vue&type=style&index=0&id=478a9a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a9a1e",
  null
  
)

export default component.exports